<script>
	import Nav from "./common/Nav.svelte";
	import { Router, Route } from "svelte-routing";
	import Home from "./home/Home.svelte";
	import Map from "./map/Map.svelte";
	import Product from "./product/Product.svelte";
  	export let url = "";

</script>
<style>
	footer { 
		background-color: inherit;
		border-top: 1px grey solid;
		border-bottom: 1px grey solid;
		padding: 2.75rem 1.5rem 3rem;
		margin-bottom: 1.5rem;
		margin-top: 1.5rem;
	}
	.icons li {
		display: inline;
	}
	@media(min-width:1024px){  
		footer { 
			width: 80%;
			margin-right: auto;
    		margin-left: auto;
		}
	}
</style>
<svelte:head>
  <style src="./scss/scss-entrypoint.scss"></style>
</svelte:head>

<Router url="{url}">
	<Nav/>
	<div>
	  <Route path="/product/:id" component="{Product}" />
	  <Route path="/map" component="{Map}" />
	  <Route path="/" component="{Home}" />
	</div>
  </Router>
  <footer class="footer">
    <div class="has-text-centered">
      <p>
        &copy; Craig Chamberlain
        </p><ul class="icons">
			<li><a href="https://twitter.com/hagatorn" class="icon" target="_blank" alt="Twitter"><i class="fab fa-twitter"></i></a></li>
			<li><a href="https://www.linkedin.com/in/craig-chamberlain-61037149/" class="icon" target="_blank" alt="linkedin"><i class="fab fa-linkedin"></i></a></li>
		</ul>
      <p></p>
    </div>
  </footer>